import { render } from "./App.vue?vue&type=template&id=1ce46078"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1ce46078&lang=css"

import exportComponent from "C:\\Users\\Adewale\\OneDrive - kochind.com\\Documents\\zoloscan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__